import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class RefreshTokenResData extends ApiGenericResponse {
    token: string;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Token) this.token = obj.Token;
    }
}
